import { http } from "./http";

export type PosMonitorDashboard = {
  ok: boolean;
  generatedAt: string;
  totals: {
    devices: number;
    withOpenSession: number;
    fiscalErrors: number;
    fiscalPending: number;
  };
  devices: Array<{
    posCode: string;
    posDeviceId: string;
    location?: string | null;
    openSessionId?: string | null;
    openSince?: string | null;
    lastSaleAt?: string | null;
    fiscalPending: number;
    fiscalErrors: number;
    lastSeenAt?: string | null;
  }>;
  alerts: Array<{
    id: string;
    severity: string;
    title: string;
    message: string;
    status: string;
    lastSeenAt: string;
    posDeviceId?: string | null;
  }>;
};

export const posMonitorApi = {
  getDashboard(token: string) {
    return http<PosMonitorDashboard>("/pos/monitor/dashboard", { method: "GET" }, token);
  },
};
